/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import {
    getPayloadObject,
    getTelemetryAttributes,
    INodeProps,
    ITelemetryContent,
    Module,
    Node
} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IAAAOrderConfirmationViewProps } from './aaa_order_confirmation';
import { IAAAOrderConfirmationItemViewProps } from './components';

const WishlistItemsView: React.FC<IAAAOrderConfirmationViewProps> = props => {
    const {
        RequestOrderLines,
        orderConfirmationHeading,
        orderConfirmationContent,
        Products,
        products,
        Product,
        ProductDetails,
        ProductDimensions,
        telemetryContent,
        requestOrderId
    } = props;

    return (
        <Module {...RequestOrderLines}>
            <div className={'aaa-order-confirmation-heading'}>{orderConfirmationHeading}</div>
            <div className={'aaa-order-confirmation-text'}>
                <span>{orderConfirmationContent}</span>
                <span className={'aaa-order-number'}>Order Request No. {requestOrderId}</span>
            </div>
            {Products && products && products.length > 0 && (
                <Node {...Products}>
                    {products &&
                        products.map(product => {
                            return _renderItem(product, Product, ProductDimensions, ProductDetails, telemetryContent, requestOrderId);
                        })}
                </Node>
            )}
        </Module>
    );
};

const _renderItem = (
    product: IAAAOrderConfirmationItemViewProps,
    Product?: INodeProps,
    ProductDimensions?: INodeProps,
    ProductDetails?: INodeProps,
    telemetryContent?: ITelemetryContent,
    requestOrderId?: string
): JSX.Element | null => {
    const {
        key,
        productImage,
        productLink,
        productPrice,
        productDimensions,
        entireProductLink,
        productName,
        productAriaLabel,
        productUnitOfMeasure
    } = product;
    const payLoad = getPayloadObject('click', telemetryContent!, '', key);
    const productAttributes = getTelemetryAttributes(telemetryContent!, payLoad);
    if (entireProductLink) {
        return (
            <Node key={key} className={Product!.className} {...Product}>
                <Node
                    href={entireProductLink}
                    className={classnames('entire-product-link ', ProductDetails!.className)}
                    {...productAttributes}
                    aria-label={productAriaLabel}
                    tag={ProductDetails!.tag}
                >
                    {productImage}
                    {productName}
                    {productDimensions && ProductDimensions && (
                        <Node {...ProductDimensions}>
                            {productDimensions.map(dimension => {
                                return dimension;
                            })}
                        </Node>
                    )}
                    {productPrice}
                    {productUnitOfMeasure}
                </Node>
            </Node>
        );
    }
    return (
        <Node key={key} className={Product!.className} {...Product}>
            {productImage}
            {productLink}
            {productDimensions && ProductDimensions && (
                <Node {...ProductDimensions}>
                    {productDimensions.map(dimension => {
                        return dimension;
                    })}
                </Node>
            )}
            {productPrice}
        </Node>
    );
};

export default WishlistItemsView;
